import React from "react";
import Btn from "../components/Btn";
import { T } from "../constants/theme";
import { API_BASE_URL } from "../config";
import { useState } from "react";

export default function Dashboard({ user, onLogout }) {
  const paymentCompleted =
    user?.paymentCompleted ||
    user?.registrationStatus === "Active";

  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");
      const registrationId = sessionStorage.getItem("registrationId");

      console.log("========== PAYMENT START ==========");
      console.log("Token:", token);
      console.log("RegistrationId:", registrationId);

      // -------------------------
      // CREATE ORDER
      // -------------------------
      const response = await fetch(
        `${API_BASE_URL}/api/Registration/${registrationId}/create-order`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Create Order Status:", response.status);

      const order = await response.json();

      console.log("Create Order Response:");
      console.log(order);

      if (!response.ok) {
        throw new Error(order.message || "Unable to create payment.");
      }

      const options = {
        key: order.key,

        amount: order.amount,

        currency: "INR",

        name: "Shabbas Academy",

        description: "Scholarship Examination Registration",

        order_id: order.orderId,

        prefill: {
          name: user.studentName || user.username,
          contact: user.mobile,
        },

        theme: {
          color: "#1E3A8A",
        },

        handler: async function (paymentResponse) {
          try {

            const verifyBody = {
              razorpayPaymentId:
                paymentResponse.razorpay_payment_id,

              razorpayOrderId:
                paymentResponse.razorpay_order_id,

              razorpaySignature:
                paymentResponse.razorpay_signature,
            };

            const verifyResponse = await fetch(
              `${API_BASE_URL}/api/Registration/verify-payment`,
              {
                method: "POST",

                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },

                body: JSON.stringify(verifyBody),
              }
            );

            const verifyText =
              await verifyResponse.text();

            if (!verifyResponse.ok) {
              throw new Error(
                verifyText || "Payment verification failed."
              );
            }

            alert("Payment verified successfully.");

            window.location.reload();
          } catch (err) {
            console.error(
              "VERIFY ERROR:",
              err
            );

            alert(err.message);
          }
        },

        modal: {
          ondismiss: function () {
            console.log("Payment popup closed.");
          },
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.open();
    } catch (err) {
      console.error("CREATE ORDER ERROR:", err);

      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const card = {
    background: T.white,
    borderRadius: 14,
    padding: 22,
    marginBottom: 20,
    border: `1px solid ${T.gray200}`,
    boxShadow: "0 2px 8px rgba(0,0,0,.05)"
  };

  const row = (label, value) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: `1px solid ${T.gray100}`
      }}
    >
      <strong style={{ color: T.gray600 }}>{label}</strong>
      <span style={{ color: T.gray800 }}>{value}</span>
    </div>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: T.gray100,
        fontFamily: "'Segoe UI',sans-serif"
      }}
    >
      <div
        style={{
          background: T.indigo,
          color: T.white,
          padding: "14px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div>
          <div style={{ fontWeight: 800, fontSize: 18 }}>
            🎓 Shabbas Academy
          </div>
          <div style={{ fontSize: 12, opacity: .75 }}>
            Student Portal
          </div>
        </div>

        <Btn onClick={onLogout} variant="ghost" small>
          <span style={{ color: "white" }}>Logout</span>
        </Btn>
      </div>

      <div
        style={{
          maxWidth: 760,
          margin: "30px auto",
          padding: "0 16px"
        }}
      >
        <div
          style={{
            background: `linear-gradient(135deg, ${T.indigo}, ${T.saffron})`,
            color: T.white,
            borderRadius: 16,
            padding: 28,
            marginBottom: 22
          }}
        >
          <div style={{ fontSize: 34 }}>🎉</div>

          <h2 style={{ margin: "12px 0 8px" }}>
            Welcome, {user?.studentName || user?.username}
          </h2>

          <p style={{ opacity: .9, lineHeight: 1.7 }}>
            Thank you for registering for the <strong>Shabbas Academy
              Scholarship Examination</strong>. We are delighted to have you with
            us.
          </p>
        </div>

        <div style={card}>
          <h3 style={{ marginTop: 0, color: T.indigo }}>
            Student Information
          </h3>

          {row("Student ID", user?.studentId)}
          {row("Student Name", user?.studentName || user?.username)}
          {row("Mobile Number", user?.mobile)}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 12
            }}
          >
            <strong style={{ color: T.gray600 }}>Registration Status</strong>

            <span
              style={{
                background: paymentCompleted ? "#F6FFED" : "#FFF7E6",
                color: paymentCompleted ? "#389E0D" : "#D46B08",
                padding: "5px 12px",
                borderRadius: 20,
                fontWeight: 700,
                fontSize: 13
              }}
            >
              {paymentCompleted ? "Completed" : "Pending Payment"}
            </span>
          </div>
        </div>

        {!paymentCompleted && (
          <div
            style={{
              ...card,
              background: "#FFFBE6",
              border: "1px solid #FFD666"
            }}
          >
            <h2 style={{ marginTop: 0, color: "#D48806" }}>
              🟠 Registration Pending
            </h2>

            <p style={{ lineHeight: 1.7 }}>
              Your registration has been received successfully. To activate your
              student account and get access to examinations, please complete
              your registration fee payment.
            </p>

            <ul style={{ lineHeight: 2 }}>
              <li>Mock Tests</li>
              <li>Monthly Practice Exams</li>
              <li>Performance Reports</li>
              <li>Certificates & Rankings</li>
            </ul>

            <Btn
              onClick={handlePayment}
              disabled={loading}
            >
              {loading
                ? "Please wait..."
                : "Complete Payment"}
            </Btn>
          </div>
        )}

        {paymentCompleted && (
          <div
            style={{
              ...card,
              background: "#F6FFED",
              border: "1px solid #95DE64"
            }}
          >
            <h2 style={{ marginTop: 0, color: "#389E0D" }}>
              ✅ Registration Completed
            </h2>

            <p style={{ lineHeight: 1.8 }}>
              Your registration and payment have been completed successfully.
            </p>

            <p style={{ lineHeight: 1.8 }}>
              Future announcements, examination schedules, mock tests and other
              updates will appear here as they become available.
            </p>

            <p style={{ fontWeight: 600 }}>
              Thank you for choosing Shabbas Academy. We wish you all the very
              best!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
